import React from 'react';
import {
  List,
  Filter,
  Datagrid,
  TextField,
  ReferenceField,
  NumberField,
  DateField,
  FunctionField,
  SelectField,
  useRecordContext,
  useRedirect,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import ListPagination from '../../components/ListPagination';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { Tooltip } from '../../components';
import { Typography } from '@mui/material';
import { TaxType } from '../../models';

const LogsFilter = ({ ...props }) => (
  <Filter {...props}>
    <ReferenceInput
      source="employeeId"
      reference="employees"
      //@ts-ignore
      perPage={false}
      filter={{ role: 'admin' }}
      alwaysOn
    >
      <SelectInput
        label="Usuário"
        resettable={true}
        optionText="login"
      />
    </ReferenceInput>
    <SelectInput
      label="Tipo"
      source="type"
      optionText="name"
      choices={TaxType.taxTypeChoices}
      resettable={true}
      alwaysOn
    />
    <ReferenceInput
      source="chainId"
      reference="chains"
      //@ts-ignore
      perPage={false}
      alwaysOn
    >
      <SelectInput label="Rede" resettable={true} optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      source="companyId"
      reference="companies"
      //@ts-ignore
      perPage={false}
      alwaysOn
    >
      <SelectInput
        label="G. transportadora"
        resettable={true}
        optionText="name"
      />
    </ReferenceInput>
  </Filter>
)

enum UserLevelLabel {
  'level-1' = 'Level 1',
  'level-2' = 'Level 2',
  'level-3' = 'Level 3'
}

const HiddenTextOversizeField: React.FC<{ label: string, source: string, textAlign: string }> = ({ label, source }) => {
  return (
    <FunctionField label={label} render={(record) => record?.[source] ?
      <Tooltip title={record?.[source]}>
        <Typography>{(record?.[source] || '').slice(0, 20).concat('...')}</Typography>
      </Tooltip>
      : '--'} />
  );
}

const UserLinkField: React.FC<any> = ({ source }) => {
  const record = useRecordContext();
  const redirect = useRedirect();

  if (!record || !record[source]) {
    return null;
  }

  const handleClick = () => {
    redirect('edit', 'system-users', record.employeeId);
  };

  return (
    <Typography
      component="span"
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        color: 'primary.main',
      }}
    >
      {record[source]}
    </Typography>
  );
};

const TaxAuditLogList: React.FC<any> = ({ permissions, ...props }) => (
  <Permission permission={PERMISSIONS.TAX_AUDIT_LOG}>
    <List
      {...props}
      perPage={25}
      pagination={<ListPagination />}
      exporter={false}
      title="Logs de alterações de taxas"
      filters={<LogsFilter {...props} />}
      sort={{ field: 'eventTime', order: 'DESC' }}
    >
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <UserLinkField source="employeeLogin" label="Login" />
        <FunctionField label="Level" render={(record: { userLevel: 'level-1' | 'level-2' | 'level-3' }) => record?.userLevel ? UserLevelLabel[record.userLevel] : '--'} textAlign="center" />
        <HiddenTextOversizeField label="User Agent" source="userAgent" textAlign="center" />
        <HiddenTextOversizeField label="Payload" source="payload" textAlign="center" />
        <TextField label="Ip" source="ipAddress" textAlign="center" emptyText="--" />
        <SelectField label="Tipo" source="type" textAlign="center" choices={TaxType.taxTypeChoices} />
        <ReferenceField source="chainId" reference="chains" label="Rede" emptyText="--" textAlign="center">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="companyId" reference="companies" label="G. Transportadora" emptyText="--" textAlign="center">
          <TextField source="name" />
        </ReferenceField>
        <NumberField source="previousValue" label="Valor anterior" textAlign="center" emptyText="--" />
        <NumberField source="newValue" label="Novo valor" textAlign="center" emptyText="--" />
        <DateField source="eventTime" label="Data e hora" textAlign="center" showTime />
      </Datagrid>
    </List>
  </Permission>
);

export default TaxAuditLogList;